export default new Map<string, HTMLImageElement>();
